import { useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useHeadingLetterSpacing = ({
  letterSpacing,
  mobileLetterSpacing,
}: {
  letterSpacing?: number
  mobileLetterSpacing?: number
}) => {
  const {
    letterSpacing: globalLetterSpacing,
    mobileLetterSpacing: globalMobileLetterSpacing,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  return {
    calculatedLetterSpacing: getCalculatedProperty({
      desktopProperty: letterSpacing,
      mobileProperty: mobileLetterSpacing,
      globalDesktopProperty: globalLetterSpacing,
      globalMobileProperty: globalMobileLetterSpacing,
    }),
    globalLetterSpacing,
    globalMobileLetterSpacing,
  }
}
